import { BorderGridContainer, GridBox, H1, PortableText, Section } from '@ahmdigital/ui';
import generatePortableText from '@ahmdigital/logic/lib/content/utils/generate-portable-text';

import constants from '../../../ahm-constants';
import Head from '../../../../utils/head';
import RedirectAdapter from '../../../utils/redirect-adapter';
import styles from './styles.module.sass';
import textStyles from '../../../application/common/text.module.sass';

const headingStyles = {
  h2: { looksLike: 'h3' },
  h3: { looksLike: 'h4' },
};

export type InsurancePrivacyProps = {
  content:
    | {
        title: string;
        body: Record<string, unknown>[];
        description?: string;
      }
    | undefined;
};

const InsurancePrivacy = ({ content }: InsurancePrivacyProps) => {
  if (!content) {
    return <RedirectAdapter to={constants.URLS.SALES.ERROR_404} />;
  }

  const { title, description } = content;

  return (
    <>
      <Head>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}
      </Head>
      <BorderGridContainer hideBorderTop>
        <GridBox padding="1rem">
          <Section variant={[styles.section, textStyles.text]}>
            <H1>{content.title}</H1>
            <PortableText source={generatePortableText(content.body)} headings={headingStyles} />
          </Section>
        </GridBox>
      </BorderGridContainer>
    </>
  );
};

export default InsurancePrivacy;
